<!--
@component
Footer.Row

A row component for organizing content horizontally within the footer.

@prop css - Custom CSS styles to be applied to the row.
@prop colorVariant - The color variant of the row.

@example
<Footer.Row colorVariant="primary.subdued">
  <Footer.Group>Group 1</Footer.Group>
  <Footer.Group>Group 2</Footer.Group>
</Footer.Row>
-->

<script lang="ts">
  import type { FooterRowProps } from '../footer.types';
  import { css } from '@agapi/ui/panda/css';
  import { footerStyles } from '../footer.styles';
  import { dynamicColorString } from '@agapi/ui/panda/utils';
  import { useActions, type ActionComponentProps } from '../../../utils/useAction';

  /** Props for the Footer.Row component. */
  const { style, use, children, css: cssProp = {}, colorVariant }: FooterRowProps = $props();

  /** Classes for the footer row. */
  const classes = footerStyles.raw({});

  const staticStyles = `${colorVariant ? dynamicColorString(colorVariant) : ''} ${style}`;
</script>

<div use:useActions={use ?? []} class={css(classes.row, cssProp)} style={staticStyles}>
  {@render children?.()}
</div>